import { createSlice } from "@reduxjs/toolkit";

const category = createSlice({
  name: "user",
  initialState: {
    category: [],
  },
  reducers: {
    setCategory: (state, action) => {
      state.category = action.payload;
    },
  },
});

export const { setCategory } = category.actions;
export default category.reducer;
